export default {
  children: [
    {
      key: "/path1-uuid",
      label: "文件夹分组：分组一",
      type: "folder",
      icon: "AccountBookFilled",
      children: [
        {
          key: "/path11-uuid",
          label: "文件夹分组：分组二",
          type: "folder",
          children: [
            {
              key: "/path1-uuid/path11-uuid/path111-uuid",
              pageId: "2480",
              label: "低码页面：页面1",
              type: "lowcode",
            },
            {
              key: "/path112-uuid",
              pageId: "7320",
              label: "低码页面：页面2",
              type: "lowcode",
            },
          ],
        },
        {
          key: "/path12-uuid",
          label: "文件夹分组：分组三",
          type: "folder",
          children: [
            {
              key: "/path121-uuid",
              label: "外链：外链百度",
              type: "link",
              url: "https://www.baidu.com",
            },
            {
              key: "/path122-uuid",
              label: "iframe：嵌入淘宝",
              type: "iframe",
              url: "https://www.taobao.com",
            },
            {
              key: "/path123-uuid",
              label: "iframe：嵌入榕树开放平台",
              type: "iframe",
              url: "https://smnguat.fhrons.com/saasmanage/",
            },
            {
              key: "/path124-uuid",
              label: "iframe：支付宝",
              type: "iframe",
              url: "https://www.alipay.com/",
            },
          ],
        },
      ],
    },
    {
      key: "/path2-uuid",
      label: "分组四",
      type: "folder",
      icon: "AccountBookFilled",
      children: [
        {
          key: "/path21-uuid",
          label: "微应用页面1",
          type: "subApp",
          subAppName: "ice-micro-app",
        },
        {
          key: "/path22-uuid/about",
          label: "微应用页面2",
          type: "subApp",
          subAppName: "ice-micro-app",
        },
        {
          key: "/path23-uuid",
          label: "vite微应用",
          type: "subApp",
          subAppName: "vite-micro-app",
        },
      ],
    },
  ],
};
